<template>
    <div id="config" class="container flex-grow-1 pt-5 d-flex flex-column">
      <div class="flex-grow-1">
        <div class="row">
        <div class="col-sm-6">
          <div class="card mb-3">
            <div class="card-header">
              {{ $t('Topics') }}
            </div>
            <div class="card-body">
              <div class="text-danger" v-if="topicError">{{ $t('Please choose at least one topic.') }}</div>
              <div class="form-check is-invalid" v-for="(item, index) in allTopics" v-bind:key="index" v-bind:item="item" v-bind:index="index">
                <input class="form-check-input" v-bind:class="{'is-invalid': topicError}" :id="'topic' + index + $i18n.locale" type="checkbox" :value="item" v-model="proxySelectedTopics">
                <label class="form-check-label" :for="'topic' + index + $i18n.locale">
                  {{ item }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card mb-3">
            <div class="card-header">
              {{ $t('Language') }}
            </div>
            <div class="card-body">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="lang" id="lang_en" value="en" v-model="pickedLanguage">
                <label class="form-check-label" for="lang_en">
                    {{ $t('English') }}
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="lang" id="lang_de" value="de" v-model="pickedLanguage">
                <label class="form-check-label" for="lang_de">
                  {{ $t('German') }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card">
            <div class="card-header">
              {{ $t('Mode') }}
            </div>
            <div class="card-body">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" name="presentation_mode" id="presentation_mode" v-model="presentationMode">
                <label class="form-check-label" for="presentation_mode">
                  {{ $t('Presentation mode') }}
                </label>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="row d-flex align-items-end mb-5 ">
        <div class="col-sm-12">
        <button @click="submitConfig" class="btn btn-xl btn-primary float-right" style="margin-top:20px;">{{ $t('Start quiz') }}</button>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Config',
  data () {
    return {
      selectedTopics: this.$store.getters.getSelectedTopics,
      topicError: false
    }
  },
  methods: {
    submitConfig () {
      this.topicError = false
      if (!this.selectedTopics.length) {
        this.topicError = true
      } else {
        this.$store.dispatch('setSelectedQuestions')
        this.$router.push('/quiz')
      }
    }
  },
  computed: {
    ...mapGetters({
      allTopics: 'getAllTopics'
    }),
    pickedLanguage: {
      get () {
        return this.$store.getters.getLanguage
      },
      set (value) {
        this.$store.commit('setLanguage', value)
        this.$i18n.locale = value
        this.$store.dispatch('setNavTitle', this.$i18n.t('Configuration', this.$i18n.locale))
        this.selectedTopics = this.$store.getters.getAllTopics
        this.$store.commit('setSelectedTopics', this.selectedTopics)
      }
    },
    proxySelectedTopics: {
      get () {
        return this.selectedTopics
      },
      set (value) {
        this.selectedTopics = value
        this.$store.commit('setSelectedTopics', this.selectedTopics)
      }
    },
    presentationMode: {
      get () {
        return this.$store.getters.getPresentationMode
      },
      set (value) {
        this.$store.commit('setPresentationMode', value)
      }
    }
  },
  created () {
    if (!this.$store.getters.getDisplayConfig) this.$router.push('/quiz')

    this.$store.dispatch('setNavTitle', this.$i18n.t('Configuration', this.$i18n.locale))
    this.$store.dispatch('setNavSubtitle', '')
    this.$store.dispatch('setNavInfo', '')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Config.vue